import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from '../services/loader/loader.service';

export function loadingInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const loaderService = inject(LoaderService);

  // Skip loader if the header is present and set to 'true'
  if (req.headers.get('X-Skip-Loader') === 'true') {
    return next(req);
  }

  loaderService.show(); // Show loader

  return next(req).pipe(
    finalize(() => {
      loaderService.hide(); // Hide loader
    }),
  );
}
